import { connect } from 'react-redux';

import { getEditSlotUrl } from 'redux/modules/slot-booking/selectors/get-edit-slot-url';
import ChangeSlotDate from 'components/Conflict/Resolution/ChangeSlotDate/ChangeSlotDate';

export default connect(state => ({
  editSlotUrl: getEditSlotUrl(state),
}))(ChangeSlotDate);
